import axios from 'axios';

const state = {
  users: [],
  userStats: null,
  isLoading: false,
  error: null
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_USER_STATS(state, stats) {
    state.userStats = stats;
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchUsers({ commit }) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await axios.get('/admin/users');
      commit('SET_USERS', response.data.users);
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error || 'Failed to fetch users');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchUserStats({ commit }) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      const response = await axios.get('/admin/users/stats');
      commit('SET_USER_STATS', response.data.stats);
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error || 'Failed to fetch user statistics');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  allUsers: state => state.users,
  userStats: state => state.userStats,
  isLoading: state => state.isLoading,
  error: state => state.error,
  activeUsers: state => state.users.filter(user => user.isActive),
  newUsersToday: state => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return state.users.filter(user => new Date(user.createdAt) >= today);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
